/**
 * @generated SignedSource<<992a2c0fb5f90375a2f7cabfc8fc6822>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type versionStatus_softwareReleasesLaunchCard$data = {
  readonly canEdit: boolean;
  readonly id: string;
  readonly project: {
    readonly key: string;
  };
  readonly status: JiraVersionStatus;
  readonly versionId: string;
  readonly " $fragmentType": "versionStatus_softwareReleasesLaunchCard";
};
export type versionStatus_softwareReleasesLaunchCard$key = {
  readonly " $data"?: versionStatus_softwareReleasesLaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionStatus_softwareReleasesLaunchCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionStatus_softwareReleasesLaunchCard",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionId"
      },
      "action": "THROW",
      "path": "versionId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canEdit"
      },
      "action": "THROW",
      "path": "canEdit"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "7085e7fbc51810607ae42a94bf5c14e4";

export default node;
